module.exports = __webpack_public_path__ + "static/banner1.1-1fac69c2794ba5a6332f514bbfb42814.jpg";